module.exports = __webpack_public_path__ + "img/church.0e3a4870.png";